'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var AcceptableUsePolicy = function AcceptableUsePolicy() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Acceptable Use Policy | Doctify',
				pageDescription: 'Acceptable Use Policy at Doctify. Rate, review and book doctors and specialists online',
				pagePath: (0, _doctifyUtils.getResourcePath)('/acceptable-use-policy')
			},
			_react2.default.createElement(
				'div',
				{ className: _style2.default.bulletsSidebar },
				_react2.default.createElement(
					'ul',
					null,
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#acceptable-use-policy' },
							_react2.default.createElement(
								'h3',
								null,
								'Acceptable Use Policy'
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#prohibited-uses' },
							'Prohibited uses'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#interactive-services' },
							'Interactive services'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#content-standards' },
							'Content standards'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#suspension-and-termination' },
							'Suspension and termination'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#unacceptable-content' },
							'Unacceptable content'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/acceptable-use-policy#changes-to-the-acceptable-use-policy' },
							'Changes to the accptable use policy'
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.bulletsPage },
				_react2.default.createElement(
					'ol',
					null,
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'1. '
							),
							_react2.default.createElement('a', { id: 'acceptable-use-policy' }),
							'Acceptable Use Policy'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'This acceptable use policy sets out the terms between you and us under which you may access our website, ',
						_react2.default.createElement(
							'a',
							{ href: 'http://www.doctify.co.uk/' },
							_react2.default.createElement(
								'u',
								null,
								'www.doctify.co.uk'
							),
							_react2.default.createElement(
								'u',
								null,
								' '
							)
						),
						'(the "',
						_react2.default.createElement(
							'strong',
							null,
							'Website'
						),
						'"). This acceptable use policy applies to all users of, and visitors to, the Website.'
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'Your use of the Website means that you accept, and agree to abide by, all the policies in this acceptable use policy, which supplement our ',
						_react2.default.createElement(
							'a',
							{ href: '/terms-and-conditions' },
							'Website Terms & Conditions'
						),
						'.'
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'The Website is operated by Doctify Limited of Labs Triangle Building, Hatton Garden, Camden Lock Market, Chalk Farm Road, London, NW1 8AB, United Kingdom ("',
						_react2.default.createElement(
							'strong',
							null,
							'we'
						),
						'", " ',
						_react2.default.createElement(
							'strong',
							null,
							'us'
						),
						'" or "',
						_react2.default.createElement(
							'strong',
							null,
							'our'
						),
						'"). Our VAT number is 198171277.'
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'"',
						_react2.default.createElement(
							'strong',
							null,
							'users'
						),
						'", "',
						_react2.default.createElement(
							'strong',
							null,
							'you'
						),
						'" or "',
						_react2.default.createElement(
							'strong',
							null,
							'your'
						),
						'" means customers or anyone else who uses or accesses the Website.'
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'2. '
							),
							_react2.default.createElement('a', { id: 'prohibited-uses' }),
							'Prohibited uses'
						)
					),
					_react2.default.createElement(
						'ol',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'2.1. '
								),
								_react2.default.createElement('a', { id: '' }),
								'You may use the Website only for lawful purposes. You may not use the Website:'
							)
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'You may use the Website only for lawful purposes. You may not use the Website:'
							),
							_react2.default.createElement(
								'li',
								null,
								'in any way that is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effect;'
							),
							_react2.default.createElement(
								'li',
								null,
								'to interfere with any other user\u2019s use or enjoyment of the Website;'
							),
							_react2.default.createElement(
								'li',
								null,
								'to attempt to clinical diagnose yourself;'
							),
							_react2.default.createElement(
								'li',
								null,
								'to prescribe treatments to other users;'
							),
							_react2.default.createElement(
								'li',
								null,
								'to create, check, confirm, update or amend your own or someone else\u2019s databases, records, directories, customer lists, mailing or prospecting lists;'
							),
							_react2.default.createElement(
								'li',
								null,
								'to send, knowingly receive, upload, download, use or re-use any material which does not comply with our content standards (see below);'
							),
							_react2.default.createElement(
								'li',
								null,
								'to transmit, or procure the sending of, any unsolicited or unauthorised advertising or promotional material or any other form of similar solicitation (spam); and/or'
							),
							_react2.default.createElement(
								'li',
								null,
								'to knowingly transmit any data, send or upload any material that contains viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any computer software or hardware.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'2.2. '
								),
								_react2.default.createElement('a', { id: '' }),
								'You also agree:'
							)
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'not to reproduce, duplicate, copy or re-sell any part of the Website in contravention of the provisions of our terms of use;'
							),
							_react2.default.createElement(
								'li',
								null,
								'not to access without authority, interfere with, damage or disrupt:',
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										'any part of the Website;'
									),
									_react2.default.createElement(
										'li',
										null,
										'any equipment or network on which the Website is stored;'
									),
									_react2.default.createElement(
										'li',
										null,
										'any software used in the provision of the Website; or'
									),
									_react2.default.createElement(
										'li',
										null,
										'any equipment or network or software owned or used by any third party.'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'3. '
							),
							_react2.default.createElement('a', { id: 'interactive-services' }),
							'Interactive services'
						)
					),
					_react2.default.createElement(
						'ol',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'3.1. '
								),
								_react2.default.createElement('a', { id: '' }),
								'We may from time to time provide interactive services on the Website ("',
								_react2.default.createElement(
									'strong',
									null,
									'interactive services'
								),
								'").'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'3.2. '
								),
								_react2.default.createElement('a', { id: '' }),
								'Where we do provide any interactive service, we will provide clear information to you about the kind of service offered, if it is moderated and what form of moderation is used (including whether it is human or technical).'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'3.3. '
								),
								_react2.default.createElement('a', { id: '' }),
								'We will do our best to assess any possible risks for users from third parties when they use any interactive service provided on the Website, and we will decide in each case whether it is appropriate to use moderation of the relevant service (including what kind of moderation to use) in the light of those risks. However, we are under no obligation to oversee, monitor or moderate any interactive service we provide on the Website, and we expressly exclude our liability for any loss or damage arising from the use of any interactive service by a user in contravention of our content standards, whether the service is moderated or not.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'3.4. '
								),
								_react2.default.createElement('a', { id: '' }),
								'Where we do moderate an interactive service, we will normally provide you with a means of contacting the moderator, should a concern or difficulty arise.'
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'4. '
							),
							_react2.default.createElement('a', { id: 'content-standards' }),
							'Content standards'
						)
					),
					_react2.default.createElement(
						'ol',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'4.1. '
								),
								_react2.default.createElement('a', { id: '' }),
								'These content standards apply to any and all material which you contribute to the Website ("',
								_react2.default.createElement(
									'strong',
									null,
									'contributions'
								),
								'"), and to any interactive services associated with it.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'4.2. '
								),
								_react2.default.createElement('a', { id: '' }),
								'You must comply with the spirit of the following standards as well as the letter. The standards apply to each part of any contribution as well as to its whole.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'4.3. '
								),
								_react2.default.createElement('a', { id: '' }),
								'Contributions must:'
							)
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'be accurate (where they state facts);'
							),
							_react2.default.createElement(
								'li',
								null,
								'be genuinely held (where they state opinions); and/or'
							),
							_react2.default.createElement(
								'li',
								null,
								'comply with applicable law in the UK and in any country from which they are posted.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'4.4. '
								),
								_react2.default.createElement('a', { id: '' }),
								'Contributions must not:'
							)
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'contain any material which is defamatory of any person;'
							),
							_react2.default.createElement(
								'li',
								null,
								'contain any material which is obscene, offensive, hateful or inflammatory;'
							),
							_react2.default.createElement(
								'li',
								null,
								'promote sexually explicit material;'
							),
							_react2.default.createElement(
								'li',
								null,
								'promote violence;'
							),
							_react2.default.createElement(
								'li',
								null,
								'promote discrimination based on race, sex, religion, nationality, disability, sexual orientation or age;'
							),
							_react2.default.createElement(
								'li',
								null,
								'infringe any copyright, database right or trade mark of any other person;'
							),
							_react2.default.createElement(
								'li',
								null,
								'be likely to deceive any person;'
							),
							_react2.default.createElement(
								'li',
								null,
								'be made in breach of any legal duty owed to a third party, such as a contractual duty or a duty of confidence;'
							),
							_react2.default.createElement(
								'li',
								null,
								'promote any illegal activity;'
							),
							_react2.default.createElement(
								'li',
								null,
								'be threatening, abuse or invade another\u2019s privacy, or cause annoyance, inconvenience or needless anxiety;'
							),
							_react2.default.createElement(
								'li',
								null,
								'be likely to harass, upset, embarrass, alarm or annoy any other person;'
							),
							_react2.default.createElement(
								'li',
								null,
								'be used to impersonate any person, or to misrepresent your identity or affiliation with any person;'
							),
							_react2.default.createElement(
								'li',
								null,
								'give the impression that they emanate from us, if this is not the case; and/or'
							),
							_react2.default.createElement(
								'li',
								null,
								'advocate, promote or assist any unlawful act such as (by way of example only) copyright infringement or computer misuse.'
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'5. '
							),
							_react2.default.createElement('a', { id: 'suspension-and-termination' }),
							'Suspension and termination'
						)
					),
					_react2.default.createElement(
						'ol',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'5.1. '
								),
								_react2.default.createElement('a', { id: '' }),
								'We will determine, in our discretion, whether there has been a breach of this acceptable use policy through your use of the Website. When a breach of this policy has occurred, we may take such action as we deem appropriate.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'5.2. '
								),
								_react2.default.createElement('a', { id: '' }),
								'Failure to comply with this acceptable use policy constitutes a material breach of the terms of use upon which you are permitted to use the Website, and may result in our taking all or any of the following actions:'
							)
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'immediate, temporary or permanent withdrawal of your right to use the Website;'
							),
							_react2.default.createElement(
								'li',
								null,
								'immediate, temporary or permanent removal of any posting or material uploaded by you to the Website;'
							),
							_react2.default.createElement(
								'li',
								null,
								'issue of a warning to you;'
							),
							_react2.default.createElement(
								'li',
								null,
								'legal proceedings against you for reimbursement of all costs on an indemnity basis (including, but not limited to, reasonable administrative and legal costs) resulting from the breach;'
							),
							_react2.default.createElement(
								'li',
								null,
								'further legal action against you; and/or'
							),
							_react2.default.createElement(
								'li',
								null,
								'disclosure of such information to law enforcement authorities as we reasonably feel is necessary.'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'5.3. '
								),
								_react2.default.createElement('a', { id: '' }),
								'We exclude liability for actions taken in response to breaches of this acceptable use policy. The responses described in this policy are not limited, and we may take any other action we reasonably deem appropriate.'
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'6. '
							),
							_react2.default.createElement('a', { id: 'unacceptable-content' }),
							'Unacceptable content'
						)
					),
					_react2.default.createElement(
						'ol',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'6.1. '
								),
								_react2.default.createElement('a', { id: '' }),
								'If you find any content on our Website to be in any way offensive, obscene, defamatory, racist, harmful, inaccurate, unlawful, illegal, infringing of any third party rights, deceptive in any way or otherwise in breach of our content standards, please notify us by email at ',
								_react2.default.createElement(
									'b',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'mailto:dpo@doctify.co.uk' },
											'dpo@doctify.co.uk'
										),
										'.'
									)
								),
								' and using the subject heading "Unacceptable Content".'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: _style2.default.num },
									'6.2. '
								),
								_react2.default.createElement('a', { id: '' }),
								'We take complaints seriously and on receipt of your complaint we will investigate whether the content breaches our content standards or this acceptable use policy and may at our discretion, remove or block access to the content complained of.'
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'7. '
							),
							_react2.default.createElement('a', { id: 'changes-to-the-acceptable-use-policy' }),
							'Changes to the acceptable use policy'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'We may amend, modify or substitute this acceptable use policy at any time. Your continued use of the Website after any such amendment, modification or substitution constitutes your acceptance of any new acceptable use policy. We recommend that you visit our Website regularly to check for any updates or amendments to this acceptable use policy.'
					)
				)
			)
		)
	);
};

AcceptableUsePolicy.displayName = 'AcceptableUsePolicy';

AcceptableUsePolicy.defaultProps = {};

exports.default = AcceptableUsePolicy;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/acceptable-use-policy-page.js